import { AlertCircle } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/shared/state/authstore";

interface ErrorPageProps {
  title?: string;
  message?: string;
  showLogout?: boolean;
}

export function ErrorPage({
  title = "Failed to Load Application",
  message = "We encountered an error while loading your workspace. Please try again.",
  showLogout = true,
}: ErrorPageProps) {
  const navigate = useNavigate();
  const { clearAuth } = useAuthStore();

  const handleLogout = () => {
    clearAuth();
    navigate({ to: "/login" });
  };

  return (
    <div className="min-h-screen bg-surface-mute flex items-center justify-center">
      <div className="text-center space-y-6 max-w-md px-4">
        <div className="flex justify-center">
          <div className="rounded-full bg-red-100 p-3">
            <AlertCircle className="h-12 w-12 text-red-600" />
          </div>
        </div>
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-ink">{title}</h2>
          <p className="text-sm text-ink-3">{message}</p>
        </div>
        {showLogout && (
          <button
            onClick={handleLogout}
            className="px-6 py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
          >
            Return to Login
          </button>
        )}
      </div>
    </div>
  );
}
